/*
  Ecom Project - precio real cuando falta el metacampo de descuento (23-oct-2026).

  El tema muestra la rebaja leyendo custom.discount_data de cada variante
  (snippets/price.liquid). El flujo "CLUSTER | Price Rules Sync 2" (cada 30 min)
  borra ese metacampo y lo reescribe a los ~6 minutos: en ese rato las fichas y
  tarjetas muestran el precio completo, aunque el carrito cobre el descuento.

  price.liquid marca con data-ep-precio-verificar los precios cuya variante no
  tiene datos. Este script, SOLO en las ventanas del sync (hora de Lima), pide a
  Shopify el precio real de esas variantes con un carrito temporal de la API de
  Storefront (sin token; aplica los descuentos automaticos) y, si hay rebaja, la
  dibuja igual que price.liquid (precio, tachado y -X%). Consultas de hasta 50
  variantes, resultados guardados 5 min en sessionStorage. Fuera de las ventanas
  no hace nada.

  26-oct-2026: tambien se marcan los precios que ya muestran el descuento del
  metacampo. Al reescribirlo, el sync deja unos segundos un descuento menor
  (RTD Protein: -20% en vez de -30%). Solo se corrige si el carrito da un precio
  MENOR que el que se ve; nunca se quita un descuento (algunos dependen de
  condiciones que un carrito de prueba no cumple).

  02-nov-2026: Shopify Analytics contaba cada carrito temporal como "anadido al
  carrito" del visitante (49-51 % de las sesiones desde el 27/10). La consulta va
  sin cookies (credentials: 'omit') para que no se asocie a su sesion, y no se
  revisan los precios de un <dialog> cerrado (el buscador esta en todas las
  paginas): se revisan cuando el dialogo se abre.

  03-nov-2026: sin cookies no alcanzaba. El fetch de la pagina lo envuelve el
  web pixels manager de Shopify, que al ver un cartCreate con productos emite
  "product_added_to_cart" y "Added Product" (probado en vivo). La consulta usa el
  fetch nativo de un iframe oculto, que no emite nada. Si no se puede crear, no
  se consulta: nunca se vuelve al fetch de la pagina.

  03-nov-2026 (pedido de Manuel): sin consultas repetidas. La cuenta regresiva de
  la home cambia la pagina cada segundo y cada cambio volvia a pedir las variantes
  que seguian esperando respuesta. Ahora una variante en consulta no se vuelve a
  pedir (se espera esa respuesta), y las que Shopify no devuelve (agotadas, error)
  no se reintentan hasta pasado 1 minuto.

  03-nov-2026 (velocidad): fuera de las ventanas el script ya no vigila la pagina.
  Antes el MutationObserver recibia cada cambio del DOM todo el tiempo (110-160 ms
  de CPU en el celular simulado de Lighthouse en colecciones y promociones). Ahora
  espera con un temporizador a que abra la ventana. Dentro de ella, mientras hay
  una revision programada deja de escuchar: la revision mira la pagina entera.
*/
(function () {
  'use strict';
  if (window.__epPrecioReal) return;
  window.__epPrecioReal = true;

  /* minutos (hora de Lima) en que el sync borra y reescribe el metacampo, con margen */
  var VENTANAS = [[55, 59], [0, 8], [25, 38]];
  var CACHE_MS = 5 * 60 * 1000;
  var REINTENTO_MS = 60 * 1000;
  var CLAVE = 'ep_precio_real';
  var SEL = '[data-ep-precio-verificar]:not([data-ep-precio-listo])';

  /* ?ep_precio_prueba=1 en la URL: funciona fuera de las ventanas (solo para probar) */
  var PRUEBA = /[?&]ep_precio_prueba=1/.test(location.search);
  /* Lima es UTC-5 todo el año: el minuto es el mismo que en UTC */
  function enVentana() {
    if (PRUEBA) return true;
    var m = new Date().getUTCMinutes();
    return VENTANAS.some(function (v) {
      return m >= v[0] && m <= v[1];
    });
  }

  /* ms hasta que abra la proxima ventana (fuera de ellas el minuto va de 9 a 24 o de 39 a 54) */
  function hastaVentana() {
    var d = new Date();
    var m = d.getUTCMinutes();
    var inicio = m < 25 ? 25 : 55;
    return ((inicio - m) * 60 - d.getUTCSeconds()) * 1000 - d.getUTCMilliseconds() + 500;
  }

  var cache = {};
  try {
    cache = JSON.parse(sessionStorage.getItem(CLAVE) || '{}');
  } catch (e) {
    cache = {};
  }
  function guardar() {
    try {
      sessionStorage.setItem(CLAVE, JSON.stringify(cache));
    } catch (e) {
      /* sin sessionStorage: no pasa nada */
    }
  }

  /* fetch nativo de un iframe oculto: el de la pagina avisa a los pixeles de un "anadido al carrito" */
  var fetchLimpio = null;
  function pedirSinPixeles(url, opciones) {
    try {
      if (!fetchLimpio) {
        var ifr = document.createElement('iframe');
        ifr.style.display = 'none';
        ifr.setAttribute('aria-hidden', 'true');
        ifr.tabIndex = -1;
        document.body.appendChild(ifr);
        fetchLimpio = ifr.contentWindow.fetch.bind(ifr.contentWindow);
      }
      return fetchLimpio(location.origin + url, opciones);
    } catch (e) {
      return Promise.reject(e);
    }
  }

  function consultar(ids) {
    var query =
      'mutation EpPrecio($l: [CartLineInput!]!) { cartCreate(input: { lines: $l, buyerIdentity: { countryCode: PE } }) {' +
      ' cart { lines(first: 50) { nodes { merchandise { ... on ProductVariant { id } } cost { amountPerQuantity { amount } totalAmount { amount } } } } } } }';
    return pedirSinPixeles('/api/2025-07/graphql.json', {
      method: 'POST',
      credentials: 'omit',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        query: query,
        variables: {
          l: ids.map(function (id) {
            return { merchandiseId: 'gid://shopify/ProductVariant/' + id, quantity: 1 };
          })
        }
      })
    })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (d) {
        var cart = d && d.data && d.data.cartCreate && d.data.cartCreate.cart;
        if (!cart) return;
        var ahora = Date.now();
        cart.lines.nodes.forEach(function (n) {
          var id = String(n.merchandise.id).split('/').pop();
          cache[id] = { t: ahora, normal: Number(n.cost.amountPerQuantity.amount), real: Number(n.cost.totalAmount.amount) };
        });
        guardar();
      })
      .catch(function () {
        /* sin respuesta: se deja el precio como vino */
      })
      .then(function () {
        /* las que no volvieron quedan sin dato hasta el reintento, asi no se piden en cada cambio de la pagina */
        var ahora = Date.now();
        ids.forEach(function (id) {
          if (!(cache[id] && ahora - cache[id].t < 1000)) cache[id] = { t: ahora - CACHE_MS + REINTENTO_MS };
        });
        guardar();
      });
  }

  /* variantes en consulta: la siguiente revision espera esa respuesta en vez de pedirlas otra vez */
  var enCurso = {};
  function enviar(ids) {
    var p = consultar(ids).then(function () {
      ids.forEach(function (id) {
        delete enCurso[id];
      });
    });
    ids.forEach(function (id) {
      enCurso[id] = p;
    });
    return p;
  }

  /* sinCeros: como money_without_trailing_zeros ("S/. 99" en vez de "S/. 99.00") */
  function monto(n, texto, sinCeros) {
    var dec = sinCeros && Math.round(n * 100) % 100 === 0 ? 0 : 2;
    var cifra = n.toLocaleString('en-US', { minimumFractionDigits: dec, maximumFractionDigits: dec });
    return texto.replace(/\d[\d.,]*/, cifra);
  }

  function hayRebaja(c) {
    return !!(c && c.real < c.normal - 0.004);
  }

  /* numero de un precio en pantalla ("S/. 1,099.50" -> 1099.5) */
  function numero(texto) {
    var m = String(texto || '').replace(/,/g, '').match(/\d+(\.\d+)?/);
    return m ? Number(m[0]) : NaN;
  }

  /* el carrito da un precio menor que el que se ve (o no se puede leer) */
  function mejora(c, textoMostrado) {
    var visto = numero(textoMostrado);
    return hayRebaja(c) && !(c.real >= visto - 0.004);
  }

  function porcentaje(c) {
    /* en centimos, igual que price.liquid (evita el -34% por decimales) */
    var nc = Math.round(c.normal * 100);
    var rc = Math.round(c.real * 100);
    return Math.floor(((nc - rc) * 100) / nc);
  }

  /* Tarjeta de la coleccion destacada de la home (sections/ss-featured-coll-*):
     precio, tachado, etiqueta -X%, precio del boton y precios de las demas
     variantes del selector (para cuando el cliente cambie de variante). */
  function tarjetaHome(el) {
    return el.closest('.swiper-slide') || el.parentElement;
  }
  function aplicarHome(el) {
    el.setAttribute('data-ep-precio-listo', '');
    var card = tarjetaHome(el);
    var sel = card.querySelector('[data-fct8-variant-select]');
    if (sel) {
      Array.prototype.forEach.call(sel.options, function (op) {
        var co = cache[op.value];
        var b = op.getAttribute('data-price') || '';
        if (!mejora(co, b)) return;
        op.setAttribute('data-price', monto(co.real, b, true));
        op.setAttribute('data-compare-price', monto(co.normal, b, true));
      });
    }
    var c = cache[sel ? sel.value : el.getAttribute('data-ep-precio-verificar')];
    var actual = el.querySelector('.ep-card-precio-actual');
    if (!actual || !mejora(c, actual.textContent)) return;
    var base = actual.textContent.trim();
    actual.textContent = monto(c.real, base, true);
    var antes = el.querySelector('.ep-card-precio-antes');
    if (antes) {
      antes.textContent = monto(c.normal, base, true);
      antes.style.display = '';
    }
    var pct = porcentaje(c);
    var badge = card.querySelector('[data-ep-badge-desc]');
    if (badge && pct > 0) {
      badge.textContent = '-' + pct + '%';
      badge.hidden = false;
    }
    var atc = card.querySelector('[data-fct8-variant-atc-price]');
    if (atc) atc.textContent = monto(c.real, base, true);
  }

  /* Misma estructura que price.liquid cuando hay rebaja */
  function aplicar(el, c) {
    if (el.getAttribute('data-ep-precio-tipo') === 'home') return aplicarHome(el);
    el.setAttribute('data-ep-precio-listo', '');
    var visto = el.querySelector('.price');
    if (!visto || !mejora(c, visto.textContent)) return;
    var precio = el.querySelector(':scope > .price-with-badge') || el.querySelector(':scope > .price');
    if (!precio) return;
    var base = visto.textContent.trim();
    var pct = porcentaje(c);
    var caja = document.createElement('div');
    caja.className = 'price-with-badge';
    caja.innerHTML =
      '<div class="price-group">' +
      '<span role="group"><span class="visually-hidden"></span><span class="price"></span></span>' +
      '<span role="group"><span class="visually-hidden"></span><span class="compare-at-price"></span></span>' +
      '</div>' +
      (pct > 0 ? '<span class="price-discount-badge"></span>' : '');
    var ocultos = caja.querySelectorAll('.visually-hidden');
    ocultos[0].textContent = (el.getAttribute('data-ep-t-oferta') || '') + ' ';
    ocultos[1].textContent = (el.getAttribute('data-ep-t-normal') || '') + ' ';
    caja.querySelector('.price').textContent = monto(c.real, base);
    caja.querySelector('.compare-at-price').textContent = monto(c.normal, base);
    if (pct > 0) caja.querySelector('.price-discount-badge').textContent = '-' + pct + '%';
    precio.replaceWith(caja);
  }

  /* la ficha vuelve a dibujar el precio al cambiar de variante; las colecciones cargan mas productos;
     el buscador y el carrito son <dialog> que se abren despues */
  var observador = new MutationObserver(function (cambios) {
    for (var i = 0; i < cambios.length; i++) {
      if (cambios[i].addedNodes.length) return programar();
      if (cambios[i].type === 'attributes' && cambios[i].target.open) return programar();
    }
  });
  function vigilar() {
    observador.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['open'] });
  }

  /* fuera de las ventanas no se vigila nada: un temporizador vuelve a revisar cuando abre la siguiente */
  var espera = null;
  function esperarVentana() {
    observador.disconnect();
    if (!espera)
      espera = setTimeout(function () {
        espera = null;
        programar();
      }, hastaVentana());
  }

  var programado = null;
  function revisar() {
    programado = null;
    if (!enVentana()) return esperarVentana();
    vigilar();
    var els = Array.prototype.slice.call(document.querySelectorAll(SEL)).filter(function (el) {
      return !el.closest('dialog:not([open])');
    });
    if (!els.length) return;
    var ahora = Date.now();
    var faltan = [];
    var esperas = [];
    function pedir(id) {
      if (!id) return;
      if (enCurso[id]) {
        if (esperas.indexOf(enCurso[id]) === -1) esperas.push(enCurso[id]);
        return;
      }
      var c = cache[id];
      if (!(c && ahora - c.t < CACHE_MS) && faltan.indexOf(id) === -1) faltan.push(id);
    }
    els.forEach(function (el) {
      pedir(el.getAttribute('data-ep-precio-verificar'));
      /* home: tambien las demas variantes disponibles del selector sin rebaja */
      if (el.getAttribute('data-ep-precio-tipo') === 'home') {
        var sel = tarjetaHome(el).querySelector('[data-fct8-variant-select]');
        if (sel) {
          Array.prototype.forEach.call(sel.options, function (op) {
            if (!op.disabled) pedir(op.value);
          });
        }
      }
    });
    /* tandas de 50 (lo que admite la consulta), hasta 4 por revision */
    var tandas = [];
    for (var i = 0; i < faltan.length && tandas.length < 4; i += 50) tandas.push(enviar(faltan.slice(i, i + 50)));
    var listo = Promise.all(tandas.concat(esperas));
    listo.then(function () {
      els.forEach(function (el) {
        if (el.isConnected) aplicar(el, cache[el.getAttribute('data-ep-precio-verificar')]);
      });
    });
  }
  /* mientras espera la revision no escucha: los cambios de esos 300 ms los ve revisar() al mirar toda la pagina */
  function programar() {
    if (programado) return;
    observador.disconnect();
    programado = setTimeout(revisar, 300);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', programar);
  else programar();
})();
